import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, Input, Select, TextArea } from 'libs.nucleus';
import { ApiClientService, useApiClient } from 'libs.react_internal';
import { prettyJson } from '../../utils/data_reports.utils';
export const QueryInputComponent = ({ jsonValue, setQuery, setJsonValue, chartType, setChartType, }) => {
    const webApi = useApiClient(ApiClientService.WEB);
    const [isValidJson, setIsValidJson] = useState(true);
    const [prompt, setPrompt] = useState('show participants by country');
    const chartOptions = [
        { value: 'table', label: 'Table' },
        { value: 'line', label: 'Line' },
        { value: 'bar', label: 'Bar' },
        { value: 'area', label: 'Area' },
        { value: 'pie', label: 'Pie' },
    ];
    const initChartType = chartOptions.find((c) => c.value === chartType) || chartOptions[0];
    const handleChange = (event) => {
        const input = event.target.value;
        setJsonValue(input);
        try {
            JSON.parse(input); // Try parsing the input
            setIsValidJson(true); // If no error, the JSON is valid
            setQuery(JSON.parse(input)); // store only if it's valid'
        }
        catch {
            setIsValidJson(false); // If error, the JSON is invalid
        }
    };
    const callGenerative = async () => {
        const schema = 'reporting';
        try {
            const { data: resp } = await webApi.post('/api/generative/reports', {
                prompt,
                schema,
            });
            setQuery(resp.data.query);
            setJsonValue(prettyJson(resp.data.query));
        }
        catch (e) {
            console.error(e);
        }
    };
    const onSelect = (s) => setChartType(s.value);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: 'flex items-end gap-4', children: [_jsx(Input, { label: 'Prompt', width: 'lg', id: 'prompt', value: prompt, onChange: (e) => setPrompt(e.target.value) }), _jsx(Button, { label: 'Generate', onClick: callGenerative })] }), _jsxs("div", { className: 'flex gap-4 mt-4', children: [_jsx(TextArea, { width: 'lg', style: { borderColor: isValidJson ? 'gray' : 'red', borderWidth: '1px' }, label: 'Report Specification', id: 'query', value: jsonValue, onChange: handleChange }), _jsx(Select, { width: 'sm', label: 'Report Type', value: initChartType, onChange: onSelect, options: chartOptions })] })] }));
};
